import * as Yup from 'yup'

import { gamImageFormats, gamVideoFormats } from './constants'

import {
  CLICK_THROUGH_LINK,
  CLICK_THROUGH_URL_OPTION,
  DIFFERENT_URL_TYPE,
  NAME,
  SAME_URL_TYPE,
  UPLOADED_MEDIA_LIST
} from './fields'
import { urlValidation } from '../../../../../features/validations/other'
import {
  BASE64,
  MEDIA_DURATION,
  MEDIA_FORMAT,
  MEDIA_HEIGHT,
  MEDIA_SIZE,
  MEDIA_WIDTH
} from '../../../../ReusableFormFields/AdFileUpload/fields'

export const validationSchema = Yup.object({
  [NAME]: Yup.string().required('Required').max(255, 'There is a maximum limit of 255 characters'),
  [CLICK_THROUGH_LINK]: Yup.string().when(CLICK_THROUGH_URL_OPTION, {
    is: SAME_URL_TYPE,
    then: () => urlValidation
  }),
  [UPLOADED_MEDIA_LIST]: Yup.array()
    .of(
      Yup.object().shape({
        [CLICK_THROUGH_LINK]: Yup.string().when(
          [
            // $ prefix accesses parent form context from within array item validation
            '$' + CLICK_THROUGH_URL_OPTION,
            BASE64
          ],
          {
            is: (clickThroughOption, base64) => clickThroughOption === DIFFERENT_URL_TYPE && base64,
            then: () => urlValidation,
            otherwise: () => Yup.string()
          }
        )
      })
    )
    .test('mediaItems', 'Please upload at least one file', function (value) {
      const filledValue = value?.filter(item => item[BASE64])
      return !!filledValue?.length
    })
})

export const GAM_VIDEO_MAX_DURATION = 1200 // 20m = 1200s

const isValidSize = ({ supportedSizes, width, height }) => {
  return supportedSizes.some(size => size.width === width && size.height === height)
}

const allowedFormatTest = (formats, type) =>
  Yup.string().test('validFormat', `Allowed ${type} types are: .${formats.join(', .')}.`, format =>
    formats.includes(format)
  )

const createGamValidationSchema = (fileShape, supportedSizes, type) =>
  Yup.object()
    .shape(fileShape)
    .test('validSize', `Invalid ${type} dimensions, please check the supported sizes list.`, function (ad) {
      const mediaWidth = ad[MEDIA_WIDTH]
      const mediaHeight = ad[MEDIA_HEIGHT]

      const valid = isValidSize({
        supportedSizes,
        width: mediaWidth,
        height: mediaHeight
      })

      if (valid) return true

      return this.createError({
        message: `Invalid ${type} dimensions ${mediaWidth}x${mediaHeight}px, please check the supported sizes list.`
      })
    })

export const gamVideoFileShape = {
  [MEDIA_SIZE]: Yup.number().max(1900000000, 'The maximum supported video file size is 1.9 GB'),
  [MEDIA_FORMAT]: allowedFormatTest(gamVideoFormats, 'video'),
  [MEDIA_DURATION]: Yup.number().max(GAM_VIDEO_MAX_DURATION, 'Video duration should be less than 20 minutes')
}

export const gamImageFileShape = {
  [MEDIA_SIZE]: Yup.number().max(1000000, 'The maximum supported image size is 1 mb'),
  [MEDIA_FORMAT]: allowedFormatTest(gamImageFormats, 'image')
}

export const getGamImageAdValidationSchema = supportedSizes =>
  createGamValidationSchema(gamImageFileShape, supportedSizes, 'image')

export const getGamVideoAdValidationSchema = supportedSizes =>
  createGamValidationSchema(gamVideoFileShape, supportedSizes, 'video')
